export default {
  REDO: '@WS/CONTENTEDITABLE_HISTORY/REDO',
  UNDO: '@WS/CONTENTEDITABLE_HISTORY/UNDO',
};
